import Vue from 'vue';
import Vuex from 'vuex';
import * as accountInfo from './modules/account-info/index';
import * as app from './modules/app/index';
import * as user from './modules/user/index';
import * as zHeader from './modules/zHeader';
import * as accountManagement from './modules/account-management'
import * as globalDataMaintain from './modules/global-data-maintain'
import * as billingCenter from './modules/billing-center'
import * as invoiceCollect from './modules/invoiceCollect'
import * as settlementCenter from './modules/settlement-center'
import * as assetsRegister from './modules/assest-management/assets-register/index'
import * as billManagement from './modules/bill-management'
import * as recordManagement from './modules/record-management'
import * as costAccounting from './modules/cost-accounting'
function mergeStates(...modules) {
  let mappedModules = [];
  modules.forEach(m => {
    if (m.default instanceof Array) {
      mappedModules.push(...m.default)
    } else {
      mappedModules.push(m);
    }
  });
  let mergedModules = {};

  mappedModules.forEach(item => {
    if (!item.moduleId) {
      console.error("没有声明moduleId", item);
      return;
    }
    mergedModules[item.moduleId] = {
      namespaced: true,
      state: item.state,
      actions: item.actions,
      mutations: item.mutations,
      getters: item.getters
    };
  });
  return mergedModules;
}

let states = {
  namespaced: true,
  modules: {
    ...mergeStates(app, user, accountInfo, zHeader, accountManagement, globalDataMaintain, billingCenter, invoiceCollect, settlementCenter, assetsRegister, billManagement, recordManagement, costAccounting)
  }

};

Vue.use(Vuex);

const store = new Vuex.Store({
  ...states
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js